Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
stickerSize = require 'app/scripts/data/sticker-size'
MemberState = require 'app/scripts/view-models/member-state'

module.exports = class StickerSelectionView extends View
  className: 'sticker-select js-draggable-sticker'

  initialize: ->
    @listenTo MemberState,
      'change:useAnimatedStickers': @render

  enabled: ->
    !@model.get('premium') ||
    Auth.me().isFeatureEnabled('additionalStickers') ||
    @options.org?.isFeatureEnabled('additionalStickers')

  render: ->
    data = @model.toJSON()
    if @model.get('isGiphySticker') && !MemberState.getUseAnimatedStickers()
      data.url =
        Util.smallestPreviewBiggerThan(data.stillscaled, stickerSize)?.url ? data.stillUrl
    else
      data.url =
        Util.smallestPreviewBiggerThan(data.scaled, stickerSize)?.url ? data.url
    data.pending = !data.image? && !data.id? && !data.error?

    @$el
      .toggleClass('disabled', !@enabled())
      .toggleClass('giphy-sticker', !!@model.get('isGiphySticker'))
      .html(
        templates.fill(
          require('app/scripts/views/templates/sticker_select_item')
          data
        )
      )
      .data('sticker', @model) # For draggable

    @
